import axiosInstance from './axiosInstance';

export const getGPUsOrderbyStore = async (store_id, company_id) => {
  try {
    const { data } = await axiosInstance.get(`/saleOrder/GpuStoreId/${store_id}`, { params: { companyId: company_id ?? undefined } });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getWaterBlockbyStore = async (store_id, company_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/WbList/${store_id}`, { params: { companyId: company_id ?? undefined } });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getGPUsbyStoreCompany = async (store_id, company_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/GpuList`, { params: { storeId: store_id ?? undefined, companyId: company_id ?? undefined } });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getGPUsbyStoreCompanyStatus = async (store_id, company_id, status_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/GpuListStatus`, { params: { storeId: store_id ?? undefined, companyId: company_id ?? undefined, statusId: status_id ?? undefined } });
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getGPUbyId = async (gpu_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Gpu/${gpu_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getGPUbySn = async (sn) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Gpu/Sn/${sn}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getGPUbySoId = async (so_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Gpu/So/${so_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getGPULog = async (gpu_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Log/Gpu/${gpu_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getWBbySn = async (sn) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Wb/Sn/${sn}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getListBoxId = async (so_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Assembly/BoxIdList/${so_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getLastBoxId = async (ship_date) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Assembly/BoxId/${ship_date}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getAssemblybySo = async (so_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Assembly/So/${so_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getRmaList = async (so_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Log/RmaList`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getGpuListByRma = async (rma_id) => {
  try {
    const { data } = await axiosInstance.get(`/GpuWb/Log/GpuList/${rma_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const ReceiveGpuApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/GpuWb/Gpu`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditGpuApi = async (gpu_id, formData) => {
  try {
    const { data } = await axiosInstance.put(`/GpuWb/Gpu/${gpu_id}`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const UnassignGpuApi = async (gpu_id, user_id) => {
  try {
    const { data } = await axiosInstance.put(`/GpuWb/Gpu/Unassign/${gpu_id}/${user_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const UnassembleGpuApi = async (gpu_id, user_id) => {
  try {
    const { data } = await axiosInstance.put(`/GpuWb/Assembly/Unassemble/${gpu_id}/${user_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const FailGpuApi = async (formData) => {
  try {
    const { data } = await axiosInstance.put(`/GpuWb/Gpu/Fail`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const TestGpuApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/GpuWb/GpuTest`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const TestGpuAssemblyApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/GpuWb/GpuAssemblyTest`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const CreateAssemblyApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/GpuWb/Assembly`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const ShipAssemblyApi = async (formData) => {
  try {
    const { data } = await axiosInstance.put(`/GpuWb/Assembly/Ship`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const ReceiveWbApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/GpuWb/Wb`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const ImportWbApi = async (formData) => {
  try {
    const { data } = await axiosInstance.post(`/GpuWb/upload`, formData);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};
